import React from 'react';
import _ from 'lodash';
import { Tooltip } from 'antd';

export function formatNumber({count, onlyString = false, showTooltip = true, fontSize = 10 }) {
    if(!_.isNumber(count)) return count;

    let formattedNumber = count.toString();

    const ranges = [{
        divider: 1E3,
        suffix: 'K'
    }, {
        divider: 1E6,
        suffix: 'M'
    }, {
        divider: 1E9,
        suffix: 'B'
    }];

    for (let index = ranges.length - 1; index >= 0; index--) {
        if (count > ranges[index].divider) {
            let quotient = count / ranges[index].divider;

            if (quotient < 10) {
                quotient = Math.floor(quotient * 10) / 10;
            } else {
                quotient = Math.floor(quotient);
            }

            formattedNumber = quotient.toString() + ranges[index].suffix;
            break;
        }
    }
    const formattedString = onlyString ? formattedNumber : <span style={{fontSize}}>{formattedNumber}</span>
    return showTooltip ? <Tooltip title={formatNumberWithCommas(count)}>{formattedString}</Tooltip> : formattedString;  
}

export function formatNumberWithCommas(number) {
    const _number = Number(number);
    return _.isNaN(_number) ? number : _number.toLocaleString();
}

export const numberFormatter = (value) => {
    return formatNumber({count: value, onlyString: true , showTooltip: false})
}
